/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the InvoiceTranslation HTTP resource (factory product). */
export class InvoiceTranslationResource {
}

/** Angular DI token for the InvoiceTranslationPreview HTTP resource (factory product). */
export class InvoiceTranslationPreviewResource {
}

export function createInvoiceTranslationResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'invoicetranslations', () => localUserProfile, 'invoiceTranslation');
}

export function createInvoiceTranslationPreviewResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);

  return {
    preview: function(id: any, type: any): Promise<any> {
      const payProvider = type === 'BNP_PARIBAS' || type === 'PAYPAL' || type === 'PIN_PAYMENTS' ? type : 'PAYPAL';
      const uri = ApiConfig.obtain().getVersionedUri(['invoicetranslations', id, 'preview', payProvider]);
      return send({method: 'GET', url: uri, params: {withAdvertiser: true}});
    }
  };
}

export const invoiceTranslationResourceProvider = {
  provide: InvoiceTranslationResource,
  useFactory: createInvoiceTranslationResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

export const invoiceTranslationPreviewResourceProvider = {
  provide: InvoiceTranslationPreviewResource,
  useFactory: createInvoiceTranslationPreviewResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService]
};

